export default "__VITE_ASSET__Z_Xh7k1P__"